var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 59,
    viewBox: "0 0 43 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7707 19.9179C10.7707 16.5209 6.2525 15.6204 5.0538 18.7989C2.15422 26.4876 0.0415039 33.3656 0.0415039 37.0842C0.0415039 48.9353 9.64873 58.5425 21.4998 58.5425C33.351 58.5425 42.9582 48.9353 42.9582 37.0842C42.9582 33.0891 40.5196 25.4471 37.2865 17.0712C33.0984 6.22101 31.0043 0.795926 28.4194 0.503718C27.5923 0.410217 26.6899 0.578323 25.952 0.963401C23.6457 2.16683 23.6457 8.08385 23.6457 19.9179C23.6457 23.4732 20.7635 26.3554 17.2082 26.3554C13.6528 26.3554 10.7707 23.4732 10.7707 19.9179Z",
    fill: "#C27CF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.8247368185e6ecbf76068cc9bce20e42.svg";
export { ForwardRef as ReactComponent };